import { ErrorBoundary, Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { FlatList, Center } from 'native-base';
import React from 'react';

import { useRedeemRowsContext } from '../../../../contexts/redeem-rows';
import { Header } from '../Header';
import { Item } from '../Item';
import { Loading, LoadingRow } from '../Loading';
import { Separator } from '../Separator';

export const ReviewTable: React.FC = () => {
  const {
    isLoadingMoreRedeemRows,
    isLoadingRedeemRows,
    onLoadingMoreRedeemRows,
    redeemRowsData,
    redeemRowsIsError,
    redeemRowsRefresher,
  } = useRedeemRowsContext();

  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <VStack px={{ base: 0, sm: Spacing['inline.xxs'] }}>
      {isDesktop && <Header />}
      <Shadow level={2} borderTopRadius={BoxRadius.sm}>
        {isLoadingRedeemRows && <Loading />}
        {!redeemRowsIsError && !isLoadingRedeemRows && redeemRowsData.length > 0 && (
          <FlatList
            data={redeemRowsData}
            ItemSeparatorComponent={Separator}
            h={{ base: 'lg', sm: 'sm', lg: 'lg' }}
            showsVerticalScrollIndicator={false}
            keyExtractor={(item) => item.id}
            renderItem={({ item }) => <Item data={item} />}
            onEndReachedThreshold={0.2}
            onEndReached={onLoadingMoreRedeemRows}
            {...(isLoadingMoreRedeemRows && { ListFooterComponent: LoadingRow })}
            ListFooterComponentStyle={{
              paddingVertical: Utils.Token.ToInt(Spacing, 'inline.quarck'),
            }}
          />
        )}
        {(redeemRowsIsError || redeemRowsData.length === 0) && !isLoadingRedeemRows && (
          <Center h={{ base: 'lg', sm: 'sm', lg: 'lg' }}>
            <ErrorBoundary
              onRefresh={redeemRowsRefresher}
              errorIconOrIllustration="WarningIllustration"
              errorTitle="Houve um erro ao recuperar as informações da boleta."
              errorMessage="Não foi possível processar sua solicitação. Por favor, tente novamente mais tarde."
            />
          </Center>
        )}
      </Shadow>
    </VStack>
  );
};
